import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="footer-logo">
          <h2>J</h2>
        </div>

        <div className="footer-columns">
          <div className="footer-column">
            <h3>COMPANY</h3>
            <ul>
              <li>
                <Link to="/about" onClick={toTop}>
                  About Us
                </Link>
              </li>

              <li>
                <Link to="/terms" onClick={toTop}>
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" onClick={toTop}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookies" onClick={toTop}>
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>ORDERING</h3>
            <ul>
              <li>
                <Link onClick={toTop} to="/shipping">
                  Shipping Information
                </Link>
              </li>
              <li>
                <Link to="/returns" onClick={toTop}>
                  Returns & Orders
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column customer-care">
            <h3>CUSTOMER CARE</h3>
            <ul>
              <li>
                <Link to="/faqs" onClick={toTop}>
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={toTop}>
                  Contact Us
                </Link>
              </li>
            </ul>
            <div className="phone-number">
              boxes@jskerandco.club
            </div>
          </div>
        </div>
      </div>

      <div className="footer-payment">
        <div className="copyright">
          <p>Copyright © 2026 Jskerandco. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
